import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UrlsResources} from "../../core/urls-resources";
import {Observable} from "rxjs/Observable";
import { HandleError } from '../../core/handle-error';

@Injectable()
export class RegistroUsuariosService {

  constructor(protected httpClient: HttpClient,
              private handleError: HandleError,
              private urlsResources: UrlsResources) {
  }

  getUsuariosPPAPUrl(): Observable<any> {
    const options = {withCredentials: true};
    return this.httpClient.get(this.urlsResources.getUsuariosPPAPUrl(), options);
  }

  registerPpapUser(ppapUser): Observable<any> {
    const options = {withCredentials: true};
    return this.httpClient.post(this.urlsResources.getRegisterUsuariosPPAPUrl(), ppapUser, options);
  }

  getTrustedDomains(): Observable<any> {
    const options = {withCredentials: true};
    return this.httpClient.get(this.urlsResources.getTrustedRegistrationDomains(), options).catch(error =>      this.handleError.handleErrorAsObservable(error));
  }

  getRegisterRoles(): Observable<any> {
    const options = {withCredentials: true};
    return this.httpClient.get(this.urlsResources.getRegisterRolesUrl(), options).catch(error =>      this.handleError.handleErrorAsObservable(error));
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/usuariosppap/registro-usuarios.service.ts